import { render, staticRenderFns } from "./Delivery-Option.vue?vue&type=template&id=d88bc852&scoped=true&"
import script from "./Delivery-Option.vue?vue&type=script&lang=js&"
export * from "./Delivery-Option.vue?vue&type=script&lang=js&"
import style0 from "./Delivery-Option.vue?vue&type=style&index=0&id=d88bc852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88bc852",
  null
  
)

export default component.exports